<!--主布局-->
<template>
    <div class="h-100">
        <template v-if="!noLayoutRouteList.includes($route.path)">
            <header v-if="!hideLayout" class="g-header">
                <LayoutHeader
                    :is-collapsed="isMainCollapsed"
                    :width="mainCollapsedWidth"
                    :crumbs="crumbTitle"
                    @collapsedSider="$refs.SiderRef.toggleCollapse()"
                />
            </header>
            <main class="d-flex w-100 h-100">
                <aside v-if="!hideLayout" class="aside">
                    <Sider
                        ref="SiderRef"
                        v-model="isMainCollapsed"
                        class="scroll main-sider"
                        :collapsed-width="mainCollapsedWidth"
                        collapsible
                        hide-trigger
                    >
                        <MainMenu />
                    </Sider>
                </aside>
                <article class="bg-grey flex-1 right-content">
                    <div class="d-flex content">
                        <div
                            class="content-view bg-grey flex-1"
                            :class="{
                                'is-collapsed': !isCollapsed,
                                'is-fixed-btn': isFixedBtn,
                            }"
                        >
                            <slot />
                            <!-- <LayoutFooter v-if="!hideFooter" /> -->
                        </div>
                    </div>
                </article>
            </main>
        </template>
        <template v-else>
            <slot />
        </template>
    </div>
</template>

<script>
import { LayoutFooter, LayoutHeader } from './';
import { Sider } from 'view-design';
import MainMenu from './MainMenu';
import CustomIcon from '@/components/CustomIcon';
import eventBus from '@/utils/eventBus';
import { mapGetters } from 'vuex';

export default {
    name: 'MainLayout',
    components: {
        MainMenu,
        Sider,
        // SiderMenu,
        // LayoutFooter,
        LayoutHeader,
    },
    data() {
        return {
            isCollapsed: true,
            isMainCollapsed: false,
            mainCollapsedWidth: 40,
            treeData: {},
            noLayoutRouteList: ['/login', '/git-version-info'],
            hideLayout: false,
        };
    },
    computed: {
        ...mapGetters({
            routers: 'comon/routers',
        }),
        isFixedBtn() {
            return this.$route.meta.isFixedBtn;
        },
        hideFooter() {
            return this.$route.meta.hideFooter;
        },
        crumbTitle() {
            const editType = {
                edit: '编辑',
                review: '查看',
                add: '新增',
            };
            return this.$route.meta
                ? `${editType[this.$route.query.editType] || ''}${
                      this.$route.meta.title
                  }`
                : '--';
        },
    },
    created() {
        eventBus.$on('hideLayout', (status) => {
            this.hideLayout = status || !this.hideLayout;
        });
        eventBus.$on('org-change', () => {
            this.treeData = {};
            this.isCollapsed = true;
        });
        eventBus.$on('logout', () => {
            this.treeData = {};
            this.isCollapsed = true;
        });
    },
    methods: {
        settingClick() {
            const setting = this.routers.find(
                (item) => item.path === '/setting'
            );
            this.getChildren(setting);
        },
        isShow() {
            this.isCollapsed = !this.isCollapsed;
        },
    },
};
</script>

<style lang="less" scoped>
.right-content {
    height: calc(100% - 55px);
    margin-left: 11px;
}
.content {
    margin: 0 10px 0 0; /* height: calc(100% - 60px - 34px - 34px - 20px); */
    height: 100%;
    .ivu-layout-sider {
        & + .content-view {
            min-width: 1022px;
        }
    }
    .ivu-layout-sider.ivu-layout-sider-collapsed {
        & + .content-view {
            min-width: 1160px;
        }
    }
}
</style>
